// src/app/core/auth/oidc-role.service.ts
import { Injectable } from '@angular/core';
import { RoleServiceInterface } from '@core/auth/role.interface';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class OIDCRoleService implements RoleServiceInterface {
  constructor(private oauthService: OAuthService) {}

  currentUserHasRole(allowedRoles: string[]): boolean {
    const claims: any = this.oauthService.getIdentityClaims();
    if (!claims) return false;
    const realmRoles: string[] = claims.realm_access?.roles ?? [];
    const clientId = environment.oidc?.clientId;
    const clientRoles: string[] = clientId ? claims.resource_access?.[clientId]?.roles ?? [] : [];
    const userRoles = [...realmRoles, ...clientRoles];
    return userRoles.some(role => allowedRoles.includes(role));
  }
}
